import { render, staticRenderFns } from "./advertIndex.vue?vue&type=template&id=312bd13a&scoped=true&"
import script from "./advertIndex.vue?vue&type=script&lang=js&"
export * from "./advertIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312bd13a",
  null
  
)

export default component.exports